import { render, staticRenderFns } from "./SkinScoring.vue?vue&type=template&id=57af0058&scoped=true"
import script from "./SkinScoring.vue?vue&type=script&lang=js"
export * from "./SkinScoring.vue?vue&type=script&lang=js"
import style0 from "./SkinScoring.vue?vue&type=style&index=0&id=57af0058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af0058",
  null
  
)

export default component.exports